import { Button, Typography } from "@mui/material";
import React from "react";
import "./referral-banner.css";

const ReferralBannerImg = require("./../images/referral-banner.png");

export default function ReferralBanner({ isMobile }: { isMobile: boolean }) {
  return (
    <a
      rel="noreferrer"
      href="https://t.me/addlist/kZjuYNDIPO01ZmNl"
      target="_blank"
      style={{ textDecoration: "none", textTransform: "none" }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <img
          src={ReferralBannerImg}
          width={"100%"}
          alt="app-logo"
          style={{ objectFit: "contain" }}
        />
        <div
          style={{
            position: "absolute",
            padding: isMobile ? "15px" : "30px",
            top: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            style={{
              fontSize: isMobile ? "16px" : "20px",
              lineHeight: isMobile ? "20px" : "30px",
              fontWeight: "500",
            }}
          >
            Play Confidently With Us,
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? "16px" : "20px",
              lineHeight: isMobile ? "20px" : "30px",
              fontWeight: "500",
              color: "#FDE18B",

              backgroundImage:
                "linear-gradient(45deg, #FDE18B 22%, #ECB965 42%, #F8F4EE 64%, #C4913C 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            100% Guaranteed Payouts
          </Typography>
          <Typography
            style={{
              fontSize: isMobile ? "18px" : "40px",
              lineHeight: isMobile ? "30px" : "60px",
              fontWeight: "600",
            }}
          >
            Partnership
          </Typography>

          <div>
            <Button
              className="scalable-button"
              disableRipple
              style={{
                textTransform: "none",
                borderRadius: "4px",
                marginTop: isMobile ? "5px" : "10px",
                display: "flex",
                paddingRight: "10px",
                paddingLeft: "10px",
                background:
                  "linear-gradient(270deg, #FAE57F 0.36%, #E7B953 17.96%, #FFECC7 46.49%, #F1B752 76.3%, #FAE380 93.78%)",
              }}
            >
              <Typography
                style={{
                  fontWeight: "600",
                  color: "black",
                  fontSize: isMobile ? "10px" : "12px",
                }}
              >
                Join Telegram
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </a>
  );
}
